import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { apiUrl, wp_my_profile } from "../../config/config";

export const useGetProfileInfo = () => {
  const fn = () => axios.get(`${apiUrl}/${wp_my_profile}`);

  return useQuery([wp_my_profile], fn);
};

export default useGetProfileInfo;
